import { css } from '@emotion/css';

export const pinCx = css`
  .otp-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  .otp-input {
    width: 30px !important;
    height: 30px !important;
    margin: 0 5px;
    font-size: 18px;
    border-radius: 50%;
    border: 2px solid var(--colors-neutrals-50);
    background-color: var(--colors-neutrals-10);
    text-align: center;
    color: transparent;
    caret-color: transparent;
    outline: none;

    &.filled:not(.error) {
      background-color: var(--colors-primary-30);
      border-color: var(--colors-primary-10);
    }

    &.error {
      background-color: var(--colors-red-30);
      border-color: var(--colors-red-30);
    }
  }

  .otp-input:focus .otp-input:focus-visible {
    border-color: var(--colors-primary-30);
  }

  .otp-input::selection {
    color: transparent;
    background: transparent;
  }

  .otp-input::-moz-selection {
    color: transparent;
    background: transparent;
  }
`;
